import React from 'react';
import GroupBWImg1 from '../../imgs/group_online_pg.jpg';
import GroupBWImg2 from '../../imgs/group_online.jpg';
import GroupBWImg3 from '../../imgs/group_online_pg2.jpg';

const GroupBreathwork: React.FC = () => {
  return (
    <div className="min-h-screen bg-lighttan pt-28">
      <h1 className="text-4xl font-bold text-darkgreentext mb-12 text-center">
          Group Breathwork Classes
        </h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 px-4">
        <img
          src={GroupBWImg2}
          alt="Breathwork Class 1"
          className="w-full h-96 object-cover rounded-lg shadow-lg"
        />
        <img
          src={GroupBWImg1}
          alt="Breathwork Class 2"
          className="w-full h-96 object-cover rounded-lg shadow-lg"
        />
        <img
          src={GroupBWImg3}
          alt="Breathwork Class 3"
          className="w-full h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      <div className="max-w-4xl mx-auto px-8 py-16 text-center">
        <p className="text-xl text-darkgreentext leading-relaxed">
          Learn the fundamentals of breathwork in a group setting from the comfort of your home!
        </p>
      </div>
      {/*<div className="flex justify-center pb-8">
        <a
          href="https://calendly.com/seanmotiv8living/zoom-breath?back=1"
          className="px-6 py-3 bg-darkgreentext text-white rounded-lg font-bold text-xl hover:bg-greenbutton transition"
        >
          Sign Up Now
        </a>
      </div>*/}
    </div>
  );
};

export default GroupBreathwork;
